'use client';
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
var getViewSpec = function(theme, variant, color) {
    var _theme_fn = theme.fn, deriveShades = _theme_fn.deriveShades, themeColor = _theme_fn.themeColor, deriveStates = _theme_fn.deriveStates;
    var _theme_palette = theme.palette, primary = _theme_palette.primary, text = _theme_palette.text;
    if (variant === "secondary") {
        return _extends({
            default: text.medium
        }, deriveStates(text.medium, "primary"), {
            disabled: text.quaternary,
            focus: primary.mid
        });
    }
    var shades = deriveShades(themeColor(color));
    var mid = shades.mid || shades[200];
    var base = shades.base || shades[600];
    return _extends({
        default: base
    }, deriveStates(base, "primary"), {
        disabled: mid,
        focus: mid
    });
};

export { getViewSpec };
